import React from "react";
import { WifiOff, RotateCw } from "lucide-react";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";

export function LoadError({ onRetry }) {
  const { t } = useI18n();
  return (
    <div className="mx-auto flex min-h-[40vh] max-w-md flex-col items-center justify-center px-4 text-center" data-testid="load-error">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-brand-tint text-brand">
        <WifiOff size={28} />
      </span>
      <p className="mt-4 text-ink-soft">{t("loadError")}</p>
      <Button data-testid="load-retry" onClick={onRetry} className="mt-4 rounded-full bg-brand font-bold hover:bg-brand-dark">
        <RotateCw size={16} className="mr-1.5" /> {t("retry")}
      </Button>
    </div>
  );
}
